module.exports = __webpack_public_path__ + "media/images/bg/nm_faixa-25c9f75840a2dc06989e213da365f013.png";